import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M4 7C4 4.79 7.58 3 12 3C16.42 3 20 4.79 20 7C20 9.21 16.42 11 12 11C7.58 11 4 9.21 4 7ZM19.72 13.05C19.9 12.71 20 12.36 20 12V9C20 11.21 16.42 13 12 13C7.58 13 4 11.21 4 9V12C4 14.21 7.58 16 12 16C12.65 16 13.28 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.24 13 19.5 13 19.72 13.05ZM13.1 17.96C12.74 18 12.37 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19C13 18.64 13.04 18.3 13.1 17.96ZM18 18V16L15 19L18 22V20H22V18H18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Integrations"
);
